import { createFileRoute } from '@tanstack/react-router';
import { toolHead } from '../../../lib/toolHead';
import { InstagramNonFollowersPage } from '../../../pages/tools/creator-tools/InstagramNonFollowersPage';

export const Route = createFileRoute('/_site/tools/instagram-non-followers')({
  head: () => toolHead('instagram-non-followers'),
  component: InstagramNonFollowersPage,
});
